// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UBfz","badges":"styles_badges__3AyP9"};